import { AsideCard } from './aside-card'

/**
 * Beside the Motivation step. Three quotes rather than one, because a
 * single testimonial reads as the only testimonial we have.
 *
 * Attribution is the offer and the number, never a name, a gender or an
 * age — none of those make the quote more true, and a made-up headshot
 * beside a real quote makes the real quote look invented.
 */
const QUOTES = [
  {
    text: 'This was so much more productive than NeetCode.',
    by: 'Accepted offer at OpenAI · $552k',
  },
  {
    text: 'Dude, do you know what this means? You helped me triple my salary in just two months! Best investment of my life.',
    by: 'Accepted offer at Coinbase · $749k',
  },
  {
    text: 'I finally cracked Google! I failed the interview 3 times previously. Mike, at long last, shed light on why I was being scored so low despite knowing the material.',
    by: 'Accepted offer at Google · $483k',
  },
]

export function MotivationAside() {
  return (
    <AsideCard className="flex flex-col gap-4">
      <h2 className="font-medium text-sm">From people we coached</h2>
      {QUOTES.map((quote) => (
        <figure key={quote.by} className="flex flex-col gap-1.5">
          <blockquote className="text-muted-foreground text-sm leading-relaxed">
            {`“${quote.text}”`}
          </blockquote>
          <figcaption className="text-muted-foreground text-xs">
            {quote.by}
          </figcaption>
        </figure>
      ))}
    </AsideCard>
  )
}
